module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_wisdom.a22c1a8ee189b3f2a9a58057744f1613.png";